import img1 from '../images/ride-logo-removebg-preview.png'
import img2 from '../images/Safaricom-removebg-preview.png'
import img3 from '../images/ethiotel-removebg-preview.png'
import img4 from '../images/sony-removebg-preview.png'


export default[
    {
        img:img1
    },
    {
        img:img2
    },
    {
        img:img3
    },
    {
        img:img4
    },
]